export const api = {
	// Auth
	loginUser: '/users/login',
	refreshToken: '/users/refresh',

	// User
	userRegistration: '/users/registration',
	userProfile: '/users/profile',
	getUserAccount: '/users/account',
	patchUserData: '/users/account/userData',

	getAddressInvoice: 'users/account/addressInvoice',

	// Category
	fetchMainCategory: '/category/main',
	categoryFetchFilter: '/category/filter',

	// Product

	getCategoryProducts: '/category/products',

	fetchProducts: '/product',
	updateProduct: '/product/update',
	createProduct: '/product/create',
	deleteProduct: '/product/',

	fetchProductDetail: '/product/',

	//order

	gerDeliveryCalendar: '/order/deliveryCalendar',
	postNewOrder: '/order',
	getUserOrder: '/order/myOrder',

	// V2 Products

	v2AllProducts: '/product/',
	v2ProductTree: '/product/tree',
};
